import {SearchCriteria} from "./SearchCriteria";

export class UserSearchCriteria extends SearchCriteria {
  name?: string;
  email?: string;
}

